import React, { useState, useEffect, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import Html from './Html';
import { login_success, logout } from '../../../actions/user';
import ApiClient from '../../../methods/api/apiClient';
import { Routes } from "../../../methods/ApiRoutes";
const Header = memo(({ setIsOpen, isOpen }) => {
  const user = useSelector((state) => state.user);
  const toggle = () => {
    setIsOpen(!isOpen);
    localStorage.setItem('sidebar', !isOpen);
  };
  const [isOpen1, setIsOpen1] = useState(false);
  const messagecount = localStorage.getItem('unreadMessages') || 0;
  const [messageCount, setUnreadMessagesCount] = useState(messagecount);
  const history = useNavigate();
  const dispatch = useDispatch();

  const searchState = { data: '' };

  const Logout = () => {
    dispatch(logout());
    localStorage.removeItem('persist:admin-app');
    localStorage.removeItem('token');
    history('/login');
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
    // if (searchState.data) {
    //   dispatch(search_success(''))
    // }
  }, []);

  useEffect(() => {
    setSearch(searchState.data);
  }, [searchState]);

  const [search, setSearch] = useState('');

  const searchHandle = (e) => {
    e.preventDefault();
    // dispatch(search_success(search))
  };

  const searchChange = (e) => {
    setSearch(e);
    if (!e) {
      // dispatch(search_success(''))
    }
  };

  const clear = () => {
    setSearch('');
    // dispatch(search_success(''))
  };


  return (
    <Html
      isOpen={isOpen}
      toggle={toggle}
      searchHandle={searchHandle}
      search={search}
      user={user}
      searchChange={searchChange}
      isOpen1={isOpen1}
      clear={clear}
      Logout={Logout}
      messageCount={messageCount}
    />
  );
});

export default Header;
